import gsap from 'gsap'

// eslint-disable-next-line import/prefer-default-export
export function preloader() {
  const wrapper = document.querySelector('.c-preloader')
  const layer = document.querySelector('.c-preloader__layer')
  const logo = document.querySelector('.c-preloader__logo')
  const icon = document.querySelector('.c-preloader__icon-ufx')
  const tl = gsap.timeline()

  if (sessionStorage.getItem('ufxstudios.quickpreload') === 'true') {
    tl.to(logo, {
      duration: 0.6,
      autoAlpha: 1,
    })
      .to(layer, {
        clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
        transformOrigin: 'bottom',
        duration: 1.2,
        ease: 'expo.inOut',
      }, '+=1')
      .to(logo, {
        duration: 0.6,
        autoAlpha: 0,
      }, '-=1.1')
      .set(wrapper, { display: 'none' })

    // console.log('quickpreload done')
  } else {
    sessionStorage.setItem('ufxstudios.quickpreload', 'true')

    tl.to(icon, {
      duration: 0.6,
      autoAlpha: 1,
    }).to(icon, {
      duration: 0.6,
      height: window.matchMedia('(min-width:600px)').matches ? '4.45rem' : '2.82rem',
      top: 0,
      transform: 'translate(-50%, 0)',
      ease: 'power3.inOut',
    }).to(icon, {
      duration: 0.6,
      left: 0,
      transform: 'translate(0, 0)',
      ease: 'power3.inOut',
    }).to(logo, {
      duration: 0.6,
      autoAlpha: 1,
    })
      .to(layer, {
        delay: 1,
        clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
        transformOrigin: 'bottom',
        duration: 1.2,
        ease: 'expo.inOut',
      }, '-=0.4')
      .to(icon, {
        duration: 0.6,
        autoAlpha: 0,
      }, '-=1.1')
      .to(logo, {
        duration: 0.6,
        autoAlpha: 0,
      }, '-=1.1')
      .set(wrapper, { display: 'none' })

    // console.log('default preload done')
  }
}
